import styled from 'styled-components';

export const NoRecipesMsg = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export const ListContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const List = styled.div`
  margin-top: 40px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;